import { h } from 'preact'
import Header from '../header'
import Table from '../table/Table'
import { Model, TableRow } from '../table/types'

interface Props {
  rows: TableRow[],
  model: Model[],
}

const Embeddable = (props: Props) => {
  return <div className='analytics-embeddable'>
    <Header
      title='Embeddable dashboard'
      disableCancelButton
      disableSaveButton
      statusLabelText='beta'
      statusLabelSuccess
    />
    <Table {...props} />
  </div>
}

export default Embeddable
